// extracted by mini-css-extract-plugin
export default {"warning":"src-views-common-components-TileViolationWarning-TileViolationWarning__warning--_nRw4"};